import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Inject, Injectable, InjectionToken, Provider } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from '../environments/environment';

export const IS_USING_NEW_AUTHENTICATION = new InjectionToken<boolean>('whether the application is using the new authentication system');

export function getErrorHandler(): ErrorHandler {
	if (environment.production && process.env.SENTRY_RELEASE) {
		return new SentryErrorHandler(inject(IS_USING_NEW_AUTHENTICATION));
	} else {
		return new ErrorHandler();
	}
}

export function provideErrorHandler(): Provider {
	return {
		provide: ErrorHandler,
		useFactory: getErrorHandler,
		deps: [],
	};
}

export interface UserContext {
	id?: string;
	email?: string;
	is_student?: boolean;
	is_teacher?: boolean;
	is_admin?: boolean;
	is_assistant?: boolean;
	is_parent?: boolean;
	is_kiosk?: boolean;
	school_id?: string;
	school_name?: string;
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
	constructor(@Inject(IS_USING_NEW_AUTHENTICATION) isUsingNewAuthentication: boolean) {
		console.log('Error Handler Loading.', { isUsingNewAuthentication });
		Sentry.setTag('isUsingNewAuthentication', isUsingNewAuthentication);
	}

	private static reportError(error: Record<string, unknown>) {
		const isError = error instanceof Error || error instanceof HttpErrorResponse;
		Sentry.captureException(isError ? error : error.originalError || error.error || error, { extra: { error } });
	}

	handleError(error: Record<string, unknown>) {
		SentryErrorHandler.reportError(error);
		console.error(error);
	}

	setUserContext(user: UserContext) {
		Sentry.setUser(user);
	}
}
